/* Kodama gallery — Ferris-wheel belt over the public publishedPhotos feed.
 *
 * Cards travel continuously along a ring (a giant wheel whose hub sits far
 * below the viewport): they cross the center slowly and dissolve toward the
 * edges. requestAnimationFrame advances the base angle; every frame projects
 * each card to x/scale/opacity.
 *
 * Interaction: drag spins the wheel, keyboard nudges one slot, clicking a
 * side card centers it, clicking the center one opens the lightbox. Hover
 * pauses the spin. reduced-motion: static wheel.
 *
 * Data is born in the owner's dashboard (AI-labeled photos published with
 * the "Mostrar en la web" switch). This script only renders. */
(function () {
  'use strict';

  var SLOT_SECONDS = 4.5;      // time to cross one slot (base speed)
  var DRAG_SUPPRESS_PX = 8;    // drags beyond this do not count as clicks
  var NUDGE_EASE = 4.2;        // how fast a nudge gets consumed

  function endpointFor(root) {
    // Emulator only on explicit opt-in (?kgallery=emu): theme dev runs on
    // 127.0.0.1 but normally wants the real public feed.
    if (location.search.indexOf('kgallery=emu') >= 0) {
      return 'http://127.0.0.1:15001/kodama1/us-central1/publishedPhotos';
    }
    return root.getAttribute('data-endpoint') || '';
  }

  function init(root) {
    var statusEl = root.querySelector('[data-kgallery-status]');
    var stage = root.querySelector('[data-kgallery-stage]');
    var deck = root.querySelector('[data-kgallery-deck]');
    var emptyTpl = root.querySelector('[data-kgallery-empty]');
    var lightbox = root.querySelector('[data-kgallery-lightbox]');
    var lightboxImg = root.querySelector('[data-kgallery-lightbox-img]');
    var lightboxCaption = root.querySelector('[data-kgallery-lightbox-caption]');

    var masonry = root.querySelector('[data-kgallery-masonry]');
    var sentinel = root.querySelector('[data-kgallery-sentinel]');

    var photos = [];      // carousel photos (featured label, filled to 9)
    var gridPhotos = [];  // the rest, for the mosaic
    var gridShown = 0;
    var cards = [];
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ── lightbox ─────────────────────────────────────────────────── */
    root.querySelector('[data-kgallery-close]').addEventListener('click', function () {
      lightbox.close();
    });
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) lightbox.close();
    });
    function openLightbox(photo) {
      lightboxImg.src = photo.fullUrl || photo.thumbUrl;
      lightboxImg.alt = photo.caption || '';
      lightboxCaption.textContent = photo.caption || '';
      lightbox.showModal();
    }

    /* ── wheel geometry ──────────────────────────────────────────── */
    // slot: angular spacing between cards. The ring is N slots around;
    // angles normalize to [-ring/2, ring/2).
    var slot = 0.36;
    var baseAngle = 0;          // accumulated wheel rotation
    var nudge = 0;              // pending angle to consume (keys/clicks)
    var paused = false;
    var dragging = false;
    var dragMoved = 0;
    var lastT = null;
    var cardW = 260;            // measured from CSS on every layout

    function ringSize() { return photos.length * slot; }

    function normalized(a) {
      var ring = ringSize();
      a = a % ring;
      if (a < -ring / 2) a += ring;
      if (a >= ring / 2) a -= ring;
      return a;
    }

    function angleOf(i) { return normalized(baseAngle + i * slot); }

    function project(card, a) {
      // Large radius relative to the card: governs horizontal spacing.
      // No vertical drop: all cards share the same axis (only scale and
      // opacity signal distance). 7-card band (±3 slots) for the TCG
      // Pocket pack-belt feel.
      var R = cardW * 3.0;
      var x = R * Math.sin(a);
      var y = 0;
      var t = Math.min(Math.abs(a) / (slot * 3), 1);
      var scale = 1 - 0.28 * t;
      // graded opacity: full only near the center, descending toward the
      // edges (≈ 1, 1, 0.7, 0.4, 0) — the band dissolves at the edges
      // instead of being cut off.
      var fadeStart = slot * 1.2;
      var fadeEnd = slot * 4.1;
      var opacity = 1;
      if (Math.abs(a) > fadeStart) {
        opacity = Math.max(0, 1 - (Math.abs(a) - fadeStart) / (fadeEnd - fadeStart));
      }
      card.style.transform =
        'translate(calc(-50% + ' + x.toFixed(1) + 'px), calc(-50% + ' + y.toFixed(1) + 'px)) scale(' + scale.toFixed(3) + ')';
      card.style.opacity = opacity.toFixed(3);
      card.style.zIndex = String(100 - Math.round(Math.abs(a) * 100));
      card.style.pointerEvents = opacity < 0.15 ? 'none' : '';
    }

    function render() {
      cardW = deck.firstChild ? deck.firstChild.offsetWidth || cardW : cardW;
      var best = 0;
      var bestAbs = Infinity;
      cards.forEach(function (card, i) {
        var a = angleOf(i);
        project(card, a);
        if (Math.abs(a) < bestAbs) { bestAbs = Math.abs(a); best = i; }
      });
      cards.forEach(function (card, i) {
        card.setAttribute('aria-current', i === best ? 'true' : 'false');
        card.classList.toggle('is-center', i === best);
      });
    }

    function tick(t) {
      if (lastT === null) lastT = t;
      var dt = Math.min((t - lastT) / 1000, 0.1);
      lastT = t;
      var moved = false;

      if (nudge !== 0) {
        // exponential-eased nudge: fast at first, lands softly
        var step = nudge * Math.min(NUDGE_EASE * dt, 1);
        if (Math.abs(nudge - step) < 0.001) { step = nudge; }
        baseAngle += step;
        nudge -= step;
        moved = true;
      } else if (!paused && !dragging && !reducedMotion && !document.hidden && !lightbox.open && photos.length > 1) {
        baseAngle -= (slot / SLOT_SECONDS) * dt; // perpetual leftward spin
        moved = true;
      }

      if (moved) render();
      requestAnimationFrame(tick);
    }

    function nudgeBy(slots) { nudge += slots * slot; }

    /* ── deck ─────────────────────────────────────────────────────── */
    function buildDeck() {
      deck.textContent = '';
      cards = photos.map(function (photo, i) {
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'kgallery__card';
        card.setAttribute('aria-label', photo.caption || 'Foto ' + (i + 1));
        var float = document.createElement('span');
        float.className = 'kgallery__card-float';
        var img = document.createElement('img');
        img.className = 'kgallery__card-img';
        img.src = photo.thumbUrl || photo.fullUrl;
        img.alt = photo.caption || '';
        img.loading = 'lazy';
        img.decoding = 'async';
        float.appendChild(img);
        card.appendChild(float);
        card.addEventListener('click', function () {
          if (dragMoved > DRAG_SUPPRESS_PX) return; // was a drag, not a click
          var a = angleOf(i);
          if (Math.abs(a) < slot / 2) openLightbox(photo);
          else nudge += -a; // bring this card to the center
        });
        deck.appendChild(card);
        return card;
      });
      render();
    }

    /* ── navigation ──────────────────────────────────────────────── */
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') nudgeBy(1);
      if (e.key === 'ArrowRight') nudgeBy(-1);
    });

    // Dragging = spinning the wheel by hand.
    var lastX = null;
    stage.addEventListener('pointerdown', function (e) {
      dragging = true;
      dragMoved = 0;
      lastX = e.clientX;
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - lastX;
      lastX = e.clientX;
      dragMoved += Math.abs(dx);
      baseAngle += dx / (cardW * 3.0); // same R as the projection: 1:1 with the finger
      render();
    });
    window.addEventListener('pointerup', function () {
      dragging = false;
      // dragMoved is read by the click handler (fires after pointerup)
      setTimeout(function () { dragMoved = 0; }, 0);
    });
    stage.addEventListener('mouseenter', function () { paused = true; });
    stage.addEventListener('mouseleave', function () { paused = false; });

    /* ── mosaic grid ─────────────────────────────────────────────── */
    var GRID_PAGE = 30;

    function appendGridBatch() {
      var batch = gridPhotos.slice(gridShown, gridShown + GRID_PAGE);
      batch.forEach(function (photo, bi) {
        var idx = gridShown + bi;
        // Mosaic pattern repeating every 9: one 2×2 cell, one wide, one
        // tall; grid-auto-flow dense fills the holes.
        var cls = 'kgallery__tile';
        if (idx % 9 === 0) cls += ' kgallery__tile--big';
        else if (idx % 9 === 5) cls += ' kgallery__tile--wide';
        else if (idx % 9 === 7) cls += ' kgallery__tile--tall';
        var item = document.createElement('button');
        item.type = 'button';
        item.className = cls;
        item.setAttribute('aria-label', photo.caption || 'Foto');
        var img = document.createElement('img');
        img.className = 'kgallery__tile-img';
        img.src = photo.thumbUrl || photo.fullUrl;
        img.alt = photo.caption || '';
        img.loading = 'lazy';
        img.decoding = 'async';
        item.appendChild(img);
        item.addEventListener('click', function () { openLightbox(photo); });
        masonry.appendChild(item);
      });
      gridShown += batch.length;
      sentinel.hidden = gridShown >= gridPhotos.length;
    }

    function initGrid() {
      if (gridPhotos.length === 0) return;
      masonry.hidden = false;
      appendGridBatch();
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) {
            appendGridBatch();
            if (gridShown >= gridPhotos.length) io.disconnect();
          }
        }, { rootMargin: '600px' });
        io.observe(sentinel);
      } else {
        while (gridShown < gridPhotos.length) appendGridBatch();
      }
    }

    /* ── boot ─────────────────────────────────────────────────────── */
    fetch(endpointFor(root))
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var all = (data && data.photos) || [];
        var featuredLabel = (data && data.featuredLabel) || null;
        statusEl.remove();
        if (all.length === 0) {
          root.appendChild(emptyTpl.content.cloneNode(true));
          return;
        }
        // Carousel: the 9 photos of the featured label (picked by the owner
        // in the dashboard). Backfilled with the newest if short; with no
        // label configured, just the 9 newest. The rest goes to the mosaic.
        var featured = featuredLabel
          ? all.filter(function (p) { return (p.labels || []).indexOf(featuredLabel) >= 0; })
          : [];
        var carousel = featured.slice(0, 9);
        all.forEach(function (p) {
          if (carousel.length < 9 && carousel.indexOf(p) < 0) carousel.push(p);
        });
        photos = carousel;
        gridPhotos = all.filter(function (p) { return carousel.indexOf(p) < 0; });

        stage.hidden = false;
        buildDeck();
        requestAnimationFrame(tick);
        initGrid();
      })
      .catch(function () {
        statusEl.textContent = 'No pudimos cargar la galería. Intenta de nuevo más tarde.';
      });
  }

  document.querySelectorAll('[data-kgallery]').forEach(init);
})();
